/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../core/AppDispatcher'
import { AppActionTypes } from '../action/AppActions'
import { List, Record } from 'immutable'

const SnackbarState = Record({ messages: List.of() })

class SnackbarStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new SnackbarState()
  }

  reduce(state, action) {
    const payload = action.payload
    switch (action.type) {
      case AppActionTypes.snackbar:
        const message = {
          type: payload.type,
          message: payload.message,
          fadeout: payload.fadeout
        }
        return state.merge({ messages: state.messages.push(message) })
      case AppActionTypes.disposeSnackbar:
        return state.merge({ messages: state.messages.shift() })
      default:
        return state
    }
  }
}

export default new SnackbarStore()
